import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import PageTitle from "../../../components/partials/PageTitle";
import ReportFilter from "./CustomerReport/ReportFilter";
import excel from "../../../assets/images/img-icons/excel.png";
import pdf from "../../../assets/images/img-icons/pdf.png";
import { CSVLink } from "react-csv";
import { useDispatch } from "react-redux";
import { getAgentReport } from "../../../redux/slice/report/reportSlice";

const AgentReport = () => {
  const [filterData, setFilterData] = useState();
  const [filteredItem, setFilteredItem] = useState(false);

  const dispatch = useDispatch();

  const CCPdfRef = useRef();

  const { customerOverviewData } = useSelector((state) => state.report);
  const { user } = useSelector((state) => state?.auth?.user);

  const breadcrumb = {
    from: {
      title: "Reports",
      link: "/admin/reports",
    },
    current: {
      title: "Agent Report",
      link: null,
    },
  };

  const processedData = customerOverviewData?.map((row) => {
    const fullName = `${row.agentFirstName} ${row.agentLastName}`;

    return { ...row, full_name: fullName }; // Modify status property while keeping the rest
  });

  const headers = [
    { label: "Staff ID", key: "staffId" },
    { label: "Agent Name", key: "full_name" },
    { label: "Office", key: "officeName" },
    { label: "Total Policies", key: "totalPolicy" },
    { label: "Total Customers", key: "totalCustomers" },
  ];

  // print table to pdf
  const generatePDF = useReactToPrint({
    content: () => CCPdfRef.current,
    documentTitle: "Customer Payment",
  });

  useEffect(() => {
    if (filteredItem) {
      if (filterData.office_id === "") {
        const updatedFilterData = {
          ...filterData,
          office_id: user?.office_id,
        };
        dispatch(getAgentReport(updatedFilterData));
      } else {
        dispatch(getAgentReport(filterData));
      }
    }
  }, [dispatch, filterData, filteredItem, user?.office_id]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Agent Report' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row card p-1' style={{ margin: "auto 1px" }}>
        <ReportFilter
          page={"agentReport"}
          setFilterData={setFilterData}
          setFilteredItem={setFilteredItem}
          filteredItem={filteredItem}
        />
        {customerOverviewData && (
          <div className='row mb-3'>
            <>
              <div className='d-flex justify-content-end align-items-center'>
                <div className=' d-flex align-items-center border '>
                  <span
                    className='bg-info me-2 text-white'
                    style={{ padding: "3px" }}
                  >
                    Export to
                  </span>

                  <span
                    href='#'
                    id='btnExport'
                    className='me-1 cursor-p'
                    title='Export to Pdf'
                    onClick={generatePDF}
                  >
                    <img
                      src={pdf}
                      alt='export-pdf'
                      style={{ height: "25px" }}
                    />
                  </span>
                  {customerOverviewData ? (
                    <CSVLink
                      data={processedData}
                      headers={headers}
                      style={{ fontWeight: "bolder", cursor: "pointer" }}
                      filename='Agent Report'
                    >
                      <span
                        href='#'
                        id='btnExport'
                        className='mr-1'
                        title='Export to Excel'
                      >
                        <img
                          src={excel}
                          alt='export-excel'
                          style={{ height: "25px", marginRight: "5px" }}
                        />
                      </span>
                    </CSVLink>
                  ) : null}
                </div>
              </div>
              <div className='table-responsive'>
                <table
                  className='table table-centered table-striped nowrap w-100 no-footer'
                  ref={CCPdfRef}
                >
                  <thead>
                    <tr>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "100.8px" }}
                        aria-label='Email: activate to sort column ascending'
                      >
                        Staff Id
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "180.8px" }}
                        aria-label='Customer: activate to sort column ascending'
                      >
                        Agent Name
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "164.8px" }}
                        aria-label='Phone: activate to sort column ascending'
                      >
                        Office
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "144.8px" }}
                        aria-label='Phone: activate to sort column ascending'
                      >
                        Total Policies
                      </th>
                      <th
                        className='sorting'
                        tabIndex='0'
                        rowSpan='1'
                        colSpan='1'
                        style={{ width: "120.8px" }}
                        aria-label='Status: activate to sort column ascending'
                      >
                        Total Customers
                      </th>
                    </tr>
                  </thead>
                  {customerOverviewData?.length ? (
                    <tbody>
                      {customerOverviewData?.map((item, i) => (
                        <tr key={i}>
                          <td className='text-dark'>{item?.staffId}</td>
                          <td className='table-user'>
                            <span className='text-body fw-semibold'>
                              {item?.agentFirstName} {item?.agentLastName}
                            </span>
                          </td>
                          <td className='table-user'>{item?.officeName}</td>
                          <td className='table-user'>{item?.totalPolicy}</td>
                          <td className='table-user'>{item?.totalCustomers}</td>
                        </tr>
                      ))}
                    </tbody>
                  ) : null}
                </table>
                {customerOverviewData?.length < 1 ? (
                  <h5 className='alert alert-info'>No result found!</h5>
                ) : null}
              </div>
            </>
          </div>
        )}
      </div>
    </>
  );
};

export default AgentReport;
